var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholderImgFormat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 525,
    viewBox: "0 0 400 525",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M362.5 525H37.5C16.75 525 0 508.25 0 487.5V37.5C0 16.75 16.75 0 37.5 0H275L400 125V487.5C400 508.25 383.25 525 362.5 525Z",
    fill: "#E7EAF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M400 125H275V0L400 125Z",
    fill: "#F8FAFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M275 125L400 250V125H275Z",
    fill: "#BDC5D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M314.5 405.5L254.25 330.25C252.75 328.25 250.5 327 248 327H244.5C242 327 239.5 328.25 238 330.25L218.75 354.5L178.75 298.5C177.25 296.25 174.75 295 172 295.25H168.75C166.25 295.25 163.75 296.5 162.25 298.5L85.25 405.5C83.5 408 83.5 411.5 85.25 414L87.5 417.75C89 420.25 91.5 421.75 94.25 421.75H305C307.75 421.75 310.5 420.25 311.75 417.75L314 414C316.25 411.5 316.25 408 314.5 405.5ZM115 400.75L170.75 323.5L194.75 400.75H115Z",
    fill: "#377DFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M268.075 294.664C279.362 291.999 286.352 280.688 283.687 269.401C281.021 258.114 269.711 251.124 258.424 253.79C247.136 256.455 240.147 267.765 242.812 279.053C245.477 290.34 256.788 297.329 268.075 294.664Z",
    fill: "#BDC5D1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderImgFormat);
export default __webpack_public_path__ + "static/media/placeholder-img-format.57d504e8162647f238d2d6a68783248a.svg";
export { ForwardRef as ReactComponent };